import React, { Component } from "react";

import { withRouter, Link } from "react-router-dom";

// redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../store/actions/UserActions";

import styles from "./Sidebar.module.css";

class Sidebar extends Component {
  render() {
    return (
      <aside className="main-sidebar" style={{position: 'fixed'}}>
        <section className="sidebar">
          <div className="user-panel">
            <div className="pull-left image">
              <img
                src="/img/user2-160x160.jpg"
                className="img-circle"
                alt="User Image"
              />
            </div>
            <div className="pull-left info">
              <p>{this.props.user.username || "No name"}</p>
              <a>
                <i className="fa fa-circle text-success" /> Online
              </a>
            </div>
          </div>
          <form action="#" method="get" className="sidebar-form">
            <div className="input-group">
              <input
                type="text"
                name="q"
                className="form-control"
                placeholder="Search..."
              />
              <span className="input-group-btn">
                <button
                  type="submit"
                  name="search"
                  id="search-btn"
                  className="btn btn-flat"
                >
                  <i className="fa fa-search" />
                </button>
              </span>
            </div>
          </form>
          <ul className="sidebar-menu" data-widget="tree">
            <li className="header">MAIN NAVIGATION</li>
            {/* <TreeList /> */}
            <li>
              <Link to="/dashboard">
                <i className="fa fa-chart-line" /> <span>Dashboard</span>
                {/* <span className="pull-right-container">
                  <small className="label pull-right bg-red">3</small>
                  <small className="label pull-right bg-blue">17</small>
                </span> */}
              </Link>
            </li>
            <li>
              <Link to="/dashboard/tickets">
                <i className="fa fa-ticket-alt" /> <span>Tickets</span>
                {/* <span className="pull-right-container">
                  <small className="label pull-right bg-red">3</small>
                  <small className="label pull-right bg-blue">17</small>
                </span> */}
              </Link>
            </li>
            {/* <li>
              <a href="pages/mailbox/mailbox.html">
                <i className="fa fa-envelope" /> <span>Mailbox</span>
                <span className="pull-right-container">
                  <small className="label pull-right bg-yellow">12</small>
                  <small className="label pull-right bg-green">16</small>
                  <small className="label pull-right bg-red">5</small>
                </span>
              </a>
            </li> */}
            <li>
              <a
                className={styles.a}
                onClick={() =>
                  this.props.userLogout(() => {
                    this.props.history.push("/");
                  })
                }
              >
                <i className="fa fa-sign-out" /> <span>Sign out</span>
              </a>
            </li>
          </ul>
        </section>
      </aside>
    );
  }
}

const TreeList = props => {
  return (
    <li className="treeview">
      <a>
        <i className="fa fa-pie-chart" />
        <span>Charts</span>
        <span className="pull-right-container">
          <i className="fa fa-angle-left pull-right" />
        </span>
      </a>
      <ul className="treeview-menu">
        <li>
          <a href="pages/charts/chartjs.html">
            <i className="fa fa-circle-o" /> ChartJS
          </a>
        </li>
        <li>
          <a href="pages/charts/morris.html">
            <i className="fa fa-circle-o" /> Morris
          </a>
        </li>
        <li>
          <a href="pages/charts/flot.html">
            <i className="fa fa-circle-o" /> Flot
          </a>
        </li>
        <li>
          <a href="pages/charts/inline.html">
            <i className="fa fa-circle-o" /> Inline charts
          </a>
        </li>
      </ul>
    </li>
  );
};

const mapStateToProps = state => ({
  user: state.user
});

function mapDispatchToProps(dispatch) {
  return {
    userLogout: bindActionCreators(logout, dispatch)
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Sidebar)
);
